
const API_BASE_URL = "https://www.dihantech.com";

export default API_BASE_URL;
